// extracted by mini-css-extract-plugin
module.exports = {"airlineLogoText":"AirlineLogoText_airlineLogoText__qGMc0"};